import React, { useEffect, useState } from 'react';
import { Table, Button, Input } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import BasePagination from '../../../components/pagination';
import ExerciseColumns from './exercise_column';
import EditingExerciseModal from './exercise_editing_modal';

import { restApi } from '../../../apis';
//----------------------------------------------------------------------------------------------------
const ExerciseTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isBack = (location.state && location.state?.isBack) || false;
  const [startNum, setStartNum] = React.useState(
    isBack ? location.state?.startNum : 1
  );
  const [current, setCurrent] = React.useState(
    isBack ? location.state?.current : -1
  );
  const [total, setTotal] = React.useState(
    isBack ? location.state?.current : 0
  );
  const [sorts, setSorts] = React.useState(
    isBack
      ? location.state?.sorts
      : {
          orderBy: 'kor_name', //desc
          sort: 'asc', //desc
          searchTxt: '',
          refresh: new Date(),
          // selected: 'kor_name',
          // kor_name: 'asc', //desc
          // refresh: new Date(),
          // searchTxt: '',
        }
  );
  const [searchTxt, setSearchTxt] = React.useState('');
  const [dataSource, setDataSource] = React.useState([]);

  // const loading = props.loading;
  const setLoading = props.setLoading;
  const clicked = props.clicked;
  const setGModal = props.setGModal;
  //
  //----------------------------------------------------------------------------------------------------
  // 새로운 카테고리 및 영상 추가 ->버튼 클릭 효과
  useEffect(() => {
    if (String(clicked || '').length) {
      navigate(`/exercises/new`, {
        replace: true,
        state: {
          current,
          total,
          sorts,
        },
      });
    }
  }, [clicked]);
  //----------------------------------------------------------------------------------------------------
  useEffect(() => {
    // 1페이지 정보 가져오기
    if (!isBack) {
      setCurrent(1);
    }
  }, []);

  useEffect(() => {
    if(current == -1) {
      return;
    }
    
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    // 로딩
    setLoading(true);
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    (async (args) => {
      const params = {
        // pageNum: current,
        // orderBy: sorts.selected,
        // sort: sorts[sorts.selected],
        // kor_name: searchTxt,
        pageNum: current,
        orderBy: sorts.orderBy,
        sort: sorts.sort,
        searchTxt: searchTxt,
      };
      
      const response = await restApi.get(`/admin/exercise`, {
        params,
      });

      const payload = response && response.data && response.data.payload;
      if (payload) {
        setTotal(payload.totalCount || 1);
        setDataSource(payload.exercises || []);
      }
      setLoading(false);
    })();

    setTimeout(() => {
      setLoading(false);
    }, [5000]);
  }, [current, sorts]);
  // //  정렬
  // useEffect(() => {
  //   // console.log('---11-->', sorts);
  // }, [sorts]);
  //----------------------------------------------------------------------------------------------------
  const OnCellClick = (args) => {
    // const uuid = args.id;
    // navigate(`/exercises/details${uuid}`, {
    //   replace: true,
    //   state: {
    //     isBack: false,
    //     current,
    //     total,
    //     sorts,
    //   },
    // });

    const exerciseId = String(args.id).trim();
    if (exerciseId.length) {
      setGModal((prev) => {
        return {
          ...prev,
          show: true,
          component: (
            <EditingExerciseModal
              {...props}
              setState={null}
              title={'운동 수정하기'}
              exerciseId={exerciseId}
            />
          ),
        };
      });
    }
  };

  //----------------------------------------------------------------------------------------------------
  return (
    <div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '3rem',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          background: '#FFF',
          padding: 0,

          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
        }}
      >
        <div>{`통합검색`}</div>
        <Input
          style={{
            marginLeft: '1rem',
            marginRight: '1rem',
            width: '20%',
            height: '3rem',
          }}
          // value={value}
          onChange={(e) => {
            setSearchTxt(e.target.value);
          }}
          onKeyDown={(e) => {
            if(e.key == 'Enter') {
              setSorts((prev) => {
                return {
                  ...prev,
                  searchTxt: searchTxt,
                };
              });
            }
          }}
        />
        <Button
          type="primary"
          // htmlType={'submit'}
          // loading={loading}
          style={{
            display: 'flex',
            width: '6rem',
            height: '2.8rem',
            justifyContent: 'center',
            alignItem: 'center',
            background: '#7367F0',
            // font
            fontWeight: 600,
            fontSize: '1.5rem',
            lineHeight: '2.2rem',
          }}
          onClick={(e) => {
            setSorts((prev) => {
              return {
                ...prev,
                searchTxt: searchTxt,
              };
            });
          }}
        >
          {`검색`}
        </Button>
      </div>
      <Table
        columns={ExerciseColumns({
          ...props,
          sorts,
          setSorts,
          OnCellClick,
          onRefresh: () => {
            setSorts((prev) => {
              return {
                ...prev,
                refresh: new Date(),
              };
            });
          },
        })}
        dataSource={dataSource}
        pagination={false}
        showSorterTooltip = { false }
        sortDirections = {['ascend' | 'descend']}
        // components={components}
        // loading={loading}
      />
      <BasePagination
        startNum={startNum || 1}
        setStartNum={setStartNum}
        current={current}
        setCurrent={setCurrent}
        total={total}
        pageSize={10}
        {...props}
      />
    </div>
  );
};

export default ExerciseTable;
